import React from 'react'
import './ListBlock.scss'

export default ({ title, subtitle, buttons = [] }) => {
  return (
    <li className={`list-block`}>
      <h1 className="list-title-wrapper">
        <span className="list-title">{title}</span>
        <span className="list-subtitle">{subtitle}</span>
      </h1>
      <div className="list-buttons">
        {buttons.map((button, i) => (
          <button onClick={button.onClick} className="fixed" key={button.id || i}>
            {button.label}
          </button>
        ))}
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/ListBlock/ListBlock.js